import { appraisalProductCriteriaApi } from 'app/services/api';
import { formatReceivedTreeToFlat } from 'app/shared/components/common/Tree/Tree.utils';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const APPRAISAL_PRODUCT_CRITERIA_ACTION_TYPE = createNamedActions(
  'appraisalProductCriteria',
  {
    GET_APPRAISAL_PRODUCT_CRITERIA: 'GET_APPRAISAL_PRODUCT_CRITERIA',
    CREATE_APPRAISAL_PRODUCT_CRITERIA: 'CREATE_APPRAISAL_PRODUCT_CRITERIA',
    EDIT_APPRAISAL_PRODUCT_CRITERIA: 'EDIT_APPRAISAL_PRODUCT_CRITERIA',
    DELETE_APPRAISAL_PRODUCT_CRITERIA: 'DELETE_APPRAISAL_PRODUCT_CRITERIA',
  },
);

export const getAppraisalProductCriteriaAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await appraisalProductCriteriaApi.getCriteria();
  const { roots, companyId } = data || {};

  return dispatch({
    type: APPRAISAL_PRODUCT_CRITERIA_ACTION_TYPE.GET_APPRAISAL_PRODUCT_CRITERIA,
    payload: formatReceivedTreeToFlat(roots, { companyId }),
  });
});

export const createAppraisalProductCriteriaAction = catchAsyncActionError(
  body => async dispatch => {
    const { data } = await appraisalProductCriteriaApi.createCriteria(body);
    const { roots, companyId } = data || {};

    return dispatch({
      type: APPRAISAL_PRODUCT_CRITERIA_ACTION_TYPE.CREATE_APPRAISAL_PRODUCT_CRITERIA,
      payload: formatReceivedTreeToFlat(roots, { companyId }),
    });
  },
);

export const editAppraisalProductCriteriaAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await appraisalProductCriteriaApi.editCriteria(body);
  const { roots, companyId } = data || {};

  return dispatch({
    type: APPRAISAL_PRODUCT_CRITERIA_ACTION_TYPE.EDIT_APPRAISAL_PRODUCT_CRITERIA,
    payload: formatReceivedTreeToFlat(roots, { companyId }),
  });
});

export const deleteAppraisalProductCriteriaAction = catchAsyncActionError(
  ({ criteriaId }) =>
    async dispatch => {
      const { data } = await appraisalProductCriteriaApi.deleteCriteria({ criteriaId });
      const { roots, companyId } = data || {};

      return dispatch({
        type: APPRAISAL_PRODUCT_CRITERIA_ACTION_TYPE.DELETE_APPRAISAL_PRODUCT_CRITERIA,
        payload: formatReceivedTreeToFlat(roots, { companyId }),
      });
    },
);
